import React from 'react'

import Sidebar from 'components/Sidebar'
import RouteAdminClipFeedbackIndex from './feedback/clip_feedback/index'
import RouteAdminReelFeedbackIndex from './feedback/reel_feedback/index'
import { AlertCircleIcon, PlayIcon } from 'stylist'
import { Redirect, Route } from 'react-router-dom'

const RouteAdminFeedback = ({ match: { path, url } }) => (
  <Sidebar.PageContainer>
    <Sidebar>
      <Sidebar.Nav>
        <Sidebar.NavItem
          to={`${url}/clip_feedback`}
          renderIcon={() => <AlertCircleIcon />}
          label="Clip Feedback"
        />
        <Sidebar.NavItem
          to={`${url}/reel_feedback`}
          renderIcon={() => <PlayIcon />}
          label="Reel Feedback"
        />
      </Sidebar.Nav>
    </Sidebar>
    <Route
      path={path}
      exact
      render={() => <Redirect to={`${url}/clip_feedback`} />}
    />
    <Route
      path={`${path}/clip_feedback`}
      component={RouteAdminClipFeedbackIndex}
    />
    <Route
      path={`${path}/reel_feedback`}
      component={RouteAdminReelFeedbackIndex}
    />
  </Sidebar.PageContainer>
)

export default RouteAdminFeedback



// WEBPACK FOOTER //
// ./src/routes/admin/feedback.js